export const discountConfig = {
  type: {
    percent: 1,
    static: 2,
  },
};
